import { render } from "./Demo1.vue?vue&type=template&id=1c5c9d3a&scoped=true&ts=true"
import script from "./Demo1.vue?vue&type=script&lang=ts"
export * from "./Demo1.vue?vue&type=script&lang=ts"

import "./Demo1.vue?vue&type=style&index=0&id=1c5c9d3a&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5c9d3a"]])

export default __exports__